import { StyledModal } from "../../../common/shared/modal.styled";
import styled from 'styled-components';

export const MonthSelectionInfoPopUpStyled = styled(StyledModal)`
  &.header-with-bg {
    padding-left: 17px;
    padding-right: 17px;

    & .modal-dialog {
      top: 50%;
      transform: translateY(-50%);
      max-width: 700px;
      
      & .modal-content {
        border: none;
      }

      // checkbox fix
      & div:not(.check):not(.input-item) > label span {
        padding-right: ${({ ltr }) => ltr ? '20px': '0'};;
        padding-left: ${({ ltr }) => ltr ? '0': '20px'};
        user-select: none;
      }
      
      & .modal-close {
        top: 8px;
        left: 18px;
        inset-inline-end: 15px;
      }

      & .modal-icon {
        margin-bottom: 21px;
      }

      & .modal-button {
        margin-top: 15px;
        font-family: var(--bllink-font-primary);
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 1.5px;
        margin-right: auto;
      }

      & .modal-header {
        font-family: var(--bllink-font-primary);
        font-weight: 700;
        letter-spacing: 1px;
        padding-left: 40px;
        padding-right: 40px;
      }

      & .modal-body {
        text-align: start;
        font-family: var(--bllink-font-primary);

        .selection-checkbox {
          justify-content: ${({ ltr }) => ltr ? 'flex-start !important': 'flex-end'};
        }
      }
    }
  }
`;
